import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "float-container"
}
const _hoisted_2 = { class: "carousel" }
const _hoisted_3 = ["src", "onClick"]

import { useActivityStore } from '@/stores/activity';
import { goToActivityPath } from '@/view/home/supportScript';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'floatButton',
  emits: ["openAgentPopup", "openRedEnvelop", "goToHome", "openPWA", 'handleShowTreasurePopup'],
  setup(__props, { emit: __emit }) {

const activityStore = useActivityStore()
const homeIconList = computed(() => activityStore.homeFloatActivityList)
const isDisplay = ref(true)
const router = useRouter()
const emits = __emit

const handleShowTreasurePopup = (path: any) => {
    emits('handleShowTreasurePopup', path)
    localStorage.setItem('redirectFromCalim', 'true')
}

const goToPath = (name: any) => {
    goToActivityPath(name, router, handleShowTreasurePopup, emits)
}

const displaySetting = () => {
    isDisplay.value = !isDisplay.value
}


return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!

  return (isDisplay.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_van_icon, {
          name: "cross",
          color: "#fff",
          onClick: displaySetting
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_swipe, {
            autoplay: 3000,
            "lazy-render": "",
            loop: true,
            "show-indicators": false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homeIconList.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_swipe_item, { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: item?.icon,
                      alt: "",
                      class: "carouselItem",
                      onClick: ($event: any) => (goToPath(item?.name))
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})